import { useEffect, useState } from "react";
import Navbar from "./components/Navbar/Navbar";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import LoginComponent from "./pages/Login/login";
import Insights from "./pages/Events";
import "./index.css";
import ScrollToTop from "./ScrollToTop";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { RotatingLines } from "react-loader-spinner";
import {
  QueryClient,
  QueryClientProvider,
} from "@tanstack/react-query";

function Loader() {
  return (
    <RotatingLines
      strokeColor="grey"
      strokeWidth="5"
      animationDuration="0.75"
      width="96"
      visible={true}
    />
  );
}

const ProtectedRoute = ({ component: Component }) => {
  const { isAuthenticated, loginWithRedirect } = useAuth0();

  useEffect(() => {
    if (!isAuthenticated) {
      loginWithRedirect();
    }
  }, [isAuthenticated, loginWithRedirect]);

  return isAuthenticated ? <Component /> : null;
};

const queryClient = new QueryClient();

function App() {
    const mockResult = [
      {
        AlarmResponses: 0,
        Alarms: 5,
        Shutdowns: 2,
        AvgSessionLength: 279,
        ExposedBurnerAccTime: 0,
        Fire: 0,
        IsStoveRemoteUnlocked: "LOCKED",
        MaxSessionIntensity: 0,
        NumberOfSessions: 72,
        PCOFWVersion: "1.1.7",
        PresenceCounter: 46,
        PresenceRatio: 0.08,
        SCSFWVersion: "1.20.15.137#6ec5e69af335#DIRTY#DEV#a08069fa71cf",
        SensorID: "CTS_SCS_806599b99228",
        Status: "Online",
        TooHotAccTime: 52,
        UnitNumber: "Kimberley Plato",
        Warnings: 0,
        isPCOconnected: "YES",
        isStoveInUse: "NO",
        stoveCurrent: "115",
        stoveStatus: "ON",
        lastActive: "1 hour ago",
        ambientTemp: "25",
      },
      {
        AlarmResponses: 0,
        Alarms: 0,
        Shutdowns: 0,
        AvgSessionLength: NaN,
        ExposedBurnerAccTime: 0,
        Fire: 0,
        IsStoveRemoteUnlocked: "NULL",
        MaxSessionIntensity: 0,
        NumberOfSessions: 0,
        PCOFWVersion: "NULL",
        PresenceCounter: 0,
        PresenceRatio: NaN,
        SCSFWVersion: "1.20.15.23#413c88728ac5#DIRTY#DEV#38f9d3a62055",
        SensorID: "CTS_SCS_806599b992f0",
        Status: "Offline",
        TooHotAccTime: 0,
        UnitNumber: "Peter Dunlop",
        Warnings: 0,
        isPCOconnected: "NULL",
        isStoveInUse: "NO",
        stoveCurrent: "NULL",
        stoveStatus: "ON",
        lastActive: "3 days ago",
        ambientTemp: "20",
      },
      {
        AlarmResponses: 0,
        Alarms: 0,
        Shutdowns: 0,
        AvgSessionLength: NaN,
        ExposedBurnerAccTime: 0,
        Fire: 0,
        IsStoveRemoteUnlocked: "NULL",
        MaxSessionIntensity: 0,
        NumberOfSessions: 0,
        PCOFWVersion: "NULL",
        PresenceCounter: 0,
        PresenceRatio: NaN,
        SCSFWVersion: "1.20.15.1#1126878f9694#CLEAN#DEV#88d82e4ecce4",
        SensorID: "CTS_SCS_806599b99344",
        Status: "Offline",
        TooHotAccTime: 0,
        UnitNumber: "James Peters",
        Warnings: 0,
        isPCOconnected: "NULL",
        isStoveInUse: "NO",
        stoveCurrent: "NULL",
        stoveStatus: "ON",
        lastActive: "1 day ago",
        ambientTemp: "28",
      },
      {
        AlarmResponses: 1,
        Alarms: 3,
        Shutdowns: 1,
        AvgSessionLength: 194,
        ExposedBurnerAccTime: 5,
        Fire: 1,
        IsStoveRemoteUnlocked: "UNLOCKED",
        MaxSessionIntensity: 2,
        NumberOfSessions: 24,
        PCOFWVersion: "1.2.0",
        PresenceCounter: 22,
        PresenceRatio: 0.32,
        SCSFWVersion: "1.20.16.4#43aa3321d5ff#CLEAN#PROD#dd7e3a0ee12a",
        SensorID: "CTS_SCS_806599b99455",
        Status: "Online",
        TooHotAccTime: 15,
        UnitNumber: "Patricia Eby",
        Warnings: 1,
        isPCOconnected: "YES",
        isStoveInUse: "YES",
        stoveCurrent: "120",
        stoveStatus: "ON",
        lastActive: "3 hours ago",
        ambientTemp: "23",
      },
      {
        AlarmResponses: 0,
        Alarms: 0,
        Shutdowns: 0,
        AvgSessionLength: NaN,
        ExposedBurnerAccTime: 0,
        Fire: 0,
        IsStoveRemoteUnlocked: "LOCKED",
        MaxSessionIntensity: 0,
        NumberOfSessions: 0,
        PCOFWVersion: "NULL",
        PresenceCounter: 0,
        PresenceRatio: NaN,
        SCSFWVersion: "1.20.15.6#0acde28791de#DIRTY#DEV#bca91ddaaaef",
        SensorID: "CTS_SCS_806599b99566",
        Status: "Offline",
        TooHotAccTime: 0,
        UnitNumber: "Ted Willcocks",
        Warnings: 0,
        isPCOconnected: "NO",
        isStoveInUse: "NO",
        stoveCurrent: "NULL",
        stoveStatus: "OFF",
        lastActive: "5 days ago",
        ambientTemp: "21",
      },
    ];

    const [result, setResult] = useState(mockResult);
  const { isAuthenticated, isLoading, error } = useAuth0();
  if (isLoading)
    return (
      <div className="spinner">
        <Loader />
      </div>
    );
  if (error) return <div>Oops... {error.message}</div>;
    return (
      <QueryClientProvider client={queryClient}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Router>
            <ScrollToTop />
            <Navbar />
            <Routes>
              <Route
                path="/"
                element={isAuthenticated ? <Insights result={result} setResult={setResult} /> : <LoginComponent />}
              />
              <Route path="/login" element={<LoginComponent />} />
              <Route
                path="/insights"
                element={<ProtectedRoute component={Insights} />}
              />
            </Routes>
          </Router>
        </LocalizationProvider>
      </QueryClientProvider>
    );
}

export default App;
